import { KAPLAYCtx } from "kaplay";
import { GAME_HEIGHT, GAME_WIDTH } from "../../constants";
import { PALETTE, textStyle } from "../../theme";
import { Rgb } from "../../types";

const DEBRIS_COUNT = 24;

/** Text that drifts upwards and fades out. */
export function showFloatingText(k: KAPLAYCtx, text: string, x: number, y: number, rgb: Rgb): void {
    const popup = k.add([
        k.text(text, textStyle(16)),
        k.pos(x, y),
        k.anchor("center"),
        k.color(...rgb),
        k.opacity(1),
        k.z(30),
    ]);

    popup.onUpdate(() => {
        popup.pos = k.vec2(popup.pos.x, popup.pos.y - 70 * k.dt());
        popup.opacity -= 1.8 * k.dt();
        if (popup.opacity <= 0) k.destroy(popup);
    });
}

/** Screen shake, a burst of cube debris and a white flash. */
export function playVaporizeEffect(k: KAPLAYCtx, x: number, y: number, rgb: Rgb): void {
    k.shake(16);

    for (let i = 0; i < DEBRIS_COUNT; i++) {
        // Spread evenly around a circle, with some jitter so it doesn't look regular
        const angle = (Math.PI * 2 * i) / DEBRIS_COUNT + (Math.random() - 0.5);
        const speed = 120 + Math.random() * 260;
        const velocityX = Math.cos(angle) * speed;
        const velocityY = Math.sin(angle) * speed;
        const size = 6 + Math.random() * 8;
        // Mostly the cube's colour, with some channels bleached to white
        const debrisRgb = rgb.map((channel) => (Math.random() > 0.4 ? channel : 255)) as Rgb;

        const debris = k.add([
            k.rect(size, size, { radius: 2 }),
            k.pos(x, y),
            k.anchor("center"),
            k.color(...debrisRgb),
            k.opacity(1),
            k.z(35),
        ]);

        debris.onUpdate(() => {
            debris.pos = k.vec2(debris.pos.x + velocityX * k.dt(), debris.pos.y + velocityY * k.dt());
            debris.opacity -= 1.4 * k.dt();
            if (debris.opacity <= 0) k.destroy(debris);
        });
    }

    const flash = k.add([
        k.rect(GAME_WIDTH, GAME_HEIGHT),
        k.pos(0, 0),
        k.color(...PALETTE.white),
        k.opacity(0.8),
        k.z(50),
    ]);

    flash.onUpdate(() => {
        flash.opacity -= 2.5 * k.dt();
        if (flash.opacity <= 0) k.destroy(flash);
    });
}
